import React from 'react';

// === Helpers === //
import dateFormat from 'dateformat';

// === Styles === //
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoints, colors, dimensions, mixins, respondTo } from '@styles';

// === Types === //
import { Variant } from '@content/types/layout';
import { EventData } from '@content/types/page';

const EventsListContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.3);
  border-radius: 16px;
  padding: 25px 16px 23px;
  margin: 0 16px 16px 0;
  ${respondTo(
    breakpoints.md,
    css`
      width: 335px;
      margin: 16px 0;
    `
  )}
`;

const ContentTop = styled.div`
  display: flex;
  padding-bottom: 10px;
`;

const EventDate = styled.div`
  display: flex;
`;

const Image = styled.img<Disabled>`
  width: 15px;
  margin-bottom: auto;
  color: ${(props) => (props.disabled ? colors.eventDisabled : colors.ui.hcpDefault)};
`;

const ImageSecond = styled.img<Disabled>`
  width: 11px;
  margin-bottom: auto;
  fill: ${(props) => (props.disabled ? colors.eventDisabled : colors.ui.hcpDefault)};
`;

const Date = styled.p<Disabled>`
  padding-left: 5px;
  font-size: ${dimensions.fontSize.tiny}px;
  font-weight: 700;
  color: ${(props) => (props.disabled ? colors.eventDisabled : colors.text.light)};
`;

const EventLocalizatioon = styled.div<EventLocalizatioonProps>`
  display: flex;
  padding-left: ${(props) => (props.noData ? '0' : '25px')};
`;

const Text = styled.p<Disabled>`
  padding-left: 7px;
  font-size: ${dimensions.fontSize.tiny}px;
  font-weight: 700;
  color: ${(props) => (props.disabled ? colors.eventDisabled : colors.text.light)};
`;

const ContentBottom = styled.div`
  display: block;
`;

const EventName = styled.p<Disabled>`
  font-size: ${dimensions.fontSize.lg_md}px;
  margin: 0 0 8px;
  color: ${(props) => (props.disabled ? colors.eventDisabled : colors.text.default)};
  word-break: break-word;
`;

const EventUrl = styled.a<Disabled>`
  font-size: ${dimensions.fontSize.small}px;
  color: ${(props) => (props.disabled ? colors.eventDisabled : colors.ui.hcpDefault)};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  ${mixins.transitionDefault};
  word-break: break-word;
  &:hover {
    color: ${colors.ui.hcpDark};
  }
`;

interface EventsListItemProps extends EventData {
  variant: Variant;
  disabled?: boolean;
}

interface Disabled {
  disabled?: boolean;
}

interface EventLocalizatioonProps {
  noData: boolean;
}

const EventsListItem = ({
  disabled = false,
  variant,
  date,
  url,
  image1,
  image2,
  image3,
  image4,
  city,
  event_name,
}: EventsListItemProps) => {
  const formatData = () => {
    if (date.start && date.end && date.start === date.end) {
      return dateFormat(date.start, 'dd');
    } else {
      return dateFormat(date.start, 'dd mmm');
    }
  };

  return (
    <EventsListContent>
      <ContentTop>
        {(date.start || date.end) && (
          <EventDate>
            <Image disabled={disabled} src={!disabled ? image1 : image3} />

            <Date disabled={disabled}>
              {date.start && dateFormat(date.start, 'dd') !== dateFormat(date.end, 'dd')
                ? formatData()
                : ''}
              {date.start && date.end && dateFormat(date.start, 'dd') !== dateFormat(date.end, 'dd')
                ? '-'
                : ''}
              {date.end ? dateFormat(date.end, 'dd mmm') : ''}
            </Date>
          </EventDate>
        )}
        <EventLocalizatioon noData={date.start && date.end ? false : true}>
          <ImageSecond disabled={disabled} src={!disabled ? image2 : image4} />
          <Text disabled={disabled}>{city}</Text>
        </EventLocalizatioon>
      </ContentTop>
      <ContentBottom>
        <EventName disabled={disabled}>{event_name}</EventName>
        <EventUrl disabled={disabled} href={url} target="_blank">
          {url}
        </EventUrl>
      </ContentBottom>
    </EventsListContent>
  );
};

export default EventsListItem;
